export const SA_TOWNS = [
  'Aberdeen', 'Adelaide', 'Albany', 'Aliwal North', 'Allanridge',
  'Barberton', 'Beaufort West', 'Bela-Bela', 'Bellville', 'Benoni',
  'Bethlehem', 'Bethal', 'Bhisho', 'Bloemfontein', 'Boksburg',
  'Brakpan', 'Brits', 'Burgersdorp',
  'Caledon', 'Cape Town', 'Carletonville', 'Ceres', 'Clanwilliam',
  'Clarens', 'Clocolan', 'Cradock',
  'De Aar', 'Delmas', 'Dewetsdorp', 'Dundee', 'Durban',
  'East London', 'eMalahleni (Witbank)', 'Empangeni', 'Ermelo', 'Estcourt',
  'Ficksburg', 'Fort Beaufort', 'Fouriesburg', 'Frankfort', 'Fraserburg',
  'George', 'Germiston', 'Giyani', 'Graaff-Reinet', 'Grahamstown (Makhanda)',
  'Harrismith', 'Hazyview', 'Heidelberg', 'Heilbron', 'Hendrina',
  'Hermanus', 'Howick',
  'Jeffreys Bay', 'Johannesburg',
  'Kimberley', 'Kinross', 'Klerksdorp', 'Knysna', 'Kokstad',
  'Komatipoort', 'Kroonstad', 'Kuruman',
  'Ladybrand', 'Ladysmith', 'Lebowakgomo', 'Lichtenburg', 'Louis Trichardt (Makhado)',
  'Lydenburg (Mashishing)',
  'Mafikeng (Mahikeng)', 'Malmesbury', 'Margate', 'Mbombela (Nelspruit)',
  'Middelburg (Eastern Cape)', 'Middelburg (Mpumalanga)', 'Mokopane',
  'Mossel Bay', 'Mthatha', 'Musina',
  'Newcastle', 'Nigel', 'Nongoma',
  'Odendaalsrus', 'Oudtshoorn',
  'Paarl', 'Parys', 'Phalaborwa', 'Phuthaditjhaba', 'Pietermaritzburg',
  'Piet Retief', 'Piketberg', 'Plettenberg Bay', 'Polokwane', 'Port Alfred',
  'Port Elizabeth (Gqeberha)', 'Port Shepstone', 'Potchefstroom', 'Pretoria',
  'Queenstown',
  'Randburg', 'Randfontein', 'Reitz', 'Richards Bay', 'Roodepoort',
  'Rustenburg',
  'Saldanha', 'Sandton', 'Sasolburg', 'Secunda', 'Senekal',
  'Schweizer-Reneke', 'Somerset East', 'Somerset West', 'Springbok',
  'Springs', 'Standerton', 'Stellenbosch', 'Steynsrus', 'Swellendam',
  'Thabazimbi', 'Thohoyandou', 'Tzaneen',
  'Uitenhage', 'Ulundi', 'Upington',
  'Vanderbijlpark', 'Vereeniging', 'Virginia', 'Volksrust', 'Vrede',
  'Vryheid',
  'Wakkerstroom', 'Wellington', 'Welkom', 'White River', 'Winburg',
  'Wolmaransstad', 'Worcester',
  'Zastron', 'Zeerust',
];
